import { html } from 'htm/preact'

export const NavBar = () => html`
    <div class="topnavtk2" id="myTopnavtk2">
        <a href="#2021-Sept-TIFF-post-event-survey " id="2021-Sept-TIFF-post-event-survey" class="activetk2">Leave Event<//> 
        <a href="/lobby" title="Return to Lobby">Help Desk<//>
        <a href="javascript:void(0);" class="icon" onClick=${() => myFunctiontk2()}>&#9776;<//>
        <a href="https://snapshotphotobooth.vbth.app/gallery/dell" target="_blank" title="Photo Gallery">Photo Gallery</a>
        <div class="dropdowntk2"  >
            <button class="dropbtntk2">Rooms
            <i class="fa fa-caret-down"></i>
            </button>
            <div class="dropdown-contenttk2" >
                <a href="/lobby" title="Lobby">Lobby</a>
                <a href="/lounge" title="Lounge">Lounge</a>
            </div>
        </div>
    <//>
`